// อ่าน env (ต้อง prefix ด้วย REACT_APP_)
const ENV = (process.env.REACT_APP_API_ENV || 'local').toLowerCase();
const env = (key, fallback) => process.env[key] || fallback;

// กำหนดค่า default สำหรับแต่ละ environment
const MAP = {
    local: {
        API:        env('REACT_APP_LARAVEL_URL_LOCAL', 'http://127.0.0.1:8000'), // Laravel
        HOME:       env('REACT_APP_LARAVEL_URL_LOCAL', 'http://127.0.0.1:8000'), // หน้าเว็บหลัก Laravel
        NODE_URL:   env('REACT_APP_NODE_URL_LOCAL', 'http://127.0.0.1:8001'), // Node
        WEB_SOCKET_URL: env('REACT_APP_WEB_SOCKET_URL_LOCAL', 'http://127.0.0.1:8002'),
    },
    test: {
        API:        env('REACT_APP_LARAVEL_URL_TEST', 'https://ndes-test.nanyangtextile.com'),
        HOME:       env('REACT_APP_LARAVEL_URL_TEST', 'https://ndes-test.nanyangtextile.com'),
        NODE_URL:   env('REACT_APP_NODE_URL_TEST', 'https://ndes-test-back.nanyangtextile.com'),
        WEB_SOCKET_URL: env('REACT_APP_WEB_SOCKET_URL_TEST', 'https://ndes-test-ws.nanyangtextile.com'),
    },
    prod: {
        API:        env('REACT_APP_LARAVEL_URL_PROD', 'https://ndes.nanyangtextile.com'),
        HOME:       env('REACT_APP_LARAVEL_URL_PROD', 'https://ndes.nanyangtextile.com'),
        NODE_URL:   env('REACT_APP_NODE_URL_PROD', 'https://ndes-back.nanyangtextile.com'),
        WEB_SOCKET_URL: env('REACT_APP_WEB_SOCKET_URL_PROD', 'https://ndes-ws.nanyangtextile.com'),
    },
};
// เลือก config ตาม ENV (ถ้าไม่ตรง ใช้ local)
const Routers = MAP[ENV] || MAP.local;
// Audit authorization is enforced by Laravel's authenticated session.
// Keep these endpoints fixed so deployments cannot bypass that policy.
Routers.AUDIT_API = `${Routers.API}/api/audit`;
Routers.AUDITNEW_API = `${Routers.API}/api/auditnew`;
Routers.AUDIT_AUTH_URL = `${Routers.API}/auth/me`;
Routers.AUDIT_REQUEST_CONFIG = { withCredentials: true };
    console.log('[react routes]', ENV, Routers);

// if (process.env.NODE_ENV !== 'production' || process.env.NODE_ENV !== 'prod') {
//     console.log('[\\react_pj\\src\\component\\routes.js] ENV =', ENV, Routers);
// }

export default Routers;
